/**
 * Send tracking events to Facebook Pixel.
 */

import config from '@pkgs/shared-client/config';

let initialized = false;

function init() {
	if (initialized || !config.facebook.pixelEnabled) {
		return;
	}

	// Only init or run on client side
	if (typeof window === 'undefined') {
		return;
	}

	initialized = true;

	(function (f: any, b: any, e: string, v: string) {
		if (f.fbq) {
			return;
		}
		const n: any = (f.fbq = function () {
			n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
		});
		if (!f._fbq) f._fbq = n;
		n.push = n;
		n.loaded = !0;
		n.version = '2.0';
		n.queue = [];
		const t = b.createElement(e);
		t.async = !0;
		t.src = v;
		const s = b.getElementsByTagName(e)[0];
		s.parentNode?.insertBefore(t, s);
	})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

	fbq('init', config.facebook.pixelID);
}

const sendFBPixelEvent: typeof fbq = (...args: any[]) => {
	if (!config.facebook.pixelEnabled) {
		return;
	}

	// Only init or run on client side
	if (typeof window === 'undefined') {
		return;
	}

	init();

	// @ts-expect-error - ok
	fbq(...args);
};

export default sendFBPixelEvent;
